import type { ProductsGridProps } from '~/components/Slices/ProductsGrid'
import ProductsGrid from '~/components/Slices/ProductsGrid'
import NoResults from '~/components/UI/NoResults'
import {
  ClickLoadMore,
  InfiniteLoadMore,
} from '~/components/UI/ResultsGrid/ResultsGridLoadMores'

import css from './styles.module.scss'

export interface ResultsGridProps extends ProductsGridProps {
  hasNextPage: boolean
  isFetchingNextPage: boolean
  fetchNextPage: () => void
  hasLoadMoreWithClick?: boolean
}

function ResultsGrid({
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  products,
  hasLoadMoreWithClick = false,
  ...props
}: ResultsGridProps) {
  return (
    <>
      {products?.length > 0 ? (
        <>
          <ProductsGrid products={products} {...props} isCategoryPage />

          {hasLoadMoreWithClick ? (
            <ClickLoadMore
              className={css.marker}
              hasNextPage={hasNextPage}
              fetchNextPage={fetchNextPage}
              isFetchingNextPage={isFetchingNextPage}
            />
          ) : (
            <InfiniteLoadMore
              className={css.marker}
              hasNextPage={hasNextPage}
              fetchNextPage={fetchNextPage}
              isFetchingNextPage={isFetchingNextPage}
            />
          )}
        </>
      ) : (
        <NoResults />
      )}
    </>
  )
}

ResultsGrid.defaultProps = {}

export default ResultsGrid
